<template>
  <div>
    <div id="wheelofnames_siderail_left" data-freestar-ad="__336x280"></div>
    <div id="Freestar_Video_Container_Fixed"></div>
    <button id="pmLink">Privacy Manager</button>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userHasClosedAd: false, showReporting: false
      };
    },
    mounted() {
      console.log('Initializing desktop Freestar ads');
      const freestar = window.freestar
      console.log('Freestar object:', freestar);
      freestar?.config.enabled_slots.push({
        placementName: 'wheelofnames_siderail_left',
        slotId: 'wheelofnames_siderail_left'
      });
      freestar?.queue.push(() => {
        freestar.newVideo('FreeStarVideoAdContainer_slider');
      });
    },
  }

  // onUnmounted(() => {
  //   console.log('Destroying desktop Freestar ads');
  //   freestar?.queue.push(() => {
  //     freestar.deleteAdSlots();
  //     freestar.deleteVideo('FreeStarVideoAdContainer_slider');
  //   });
  // });

</script>

<style scoped>
  #pmLink {
    position: absolute;
    bottom: 0.25rem;
    left: 0.25rem;
    visibility: hidden;
    font-family: Quicksand;
    text-decoration: none;
    cursor: pointer;
    background: transparent;
    border: none;
    padding: 0;
    color: grey;
    text-align: start;
  }

  #pmLink:hover {
    visibility: visible;
    color: lightgrey;
  }
</style>
